import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { submitTemplate } from "../../../../utils/businessHoursApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import BusinessHoursTemplateWidget from "../../../../components/Apps/BusinessHours/Template/BusinessHoursTemplateWidget";
import FullBusinessDetailTemplateWidget from "../../../../components/Apps/BusinessHours/Template/FullBusinessDetailTemplateWidget";
import OpenStatusTemplateWidget from "../../../../components/Apps/BusinessHours/Template/OpenStatusTemplateWidget";
import HoursContactsTemplateWidget from "../../../../components/Apps/BusinessHours/Template/HoursContactsTemplateWidget";
import SmallContactsCardTemplateWidget from "../../../../components/Apps/BusinessHours/Template/SmallContactsCardTemplateWidget";
import DarkContactsCardTemplateWidget from "../../../../components/Apps/BusinessHours/Template/DarkContactsCardTemplateWidget";

//Import Tabs
import ContentTab from "../../../../components/Apps/BusinessHours/ContentTab";
import LayoutTab from "../../../../components/Apps/BusinessHours/LayoutTab";
import StyleTab from "../../../../components/Apps/BusinessHours/StyleTab";
import SettingTab from "../../../../components/Apps/BusinessHours/SettingTab";

export default function CreateAgeVerification() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Content");
    const [activeTemplateSection, setActiveTemplateSection] = useState("Business_Hours_Temp");
    const [selectedLayout, setSelectedLayout] = useState("business_hours_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("business-hours.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Business Hours");
    const [newWidgetName, setNewWidgetName] = useState("");
    
    const [businessHoursTabData, setBusinessHoursTabData] = useState({
        is_website_frontend: "",  
        is_sunday_on: 0,  
        sunday_start_time: "8:00 AM",  
        sunday_end_time: "5:00 PM",
        is_monday_on: 1,  
        monday_start_time: "8:00 AM",  
        monday_end_time: "5:00 PM",  
        is_tuesday_on: 1,  
        tuesday_start_time: "8:00 AM",  
        tuesday_end_time: "5:00 PM",  
        is_wednesday_on: 1,  
        wednesday_start_time: "8:00 AM",  
        wednesday_end_time: "5:00 PM",  
        is_thursday_on: 1,  
        thursday_start_time: "8:00 AM",  
        thursday_end_time: "5:00 PM",  
        is_friday_on: 1,  
        friday_start_time: "8:00 AM",  
        friday_end_time: "5:00 PM",  
        is_saturday_on: 1,  
        saturday_start_time: "8:00 AM",  
        saturday_end_time: "5:00 PM",
        business_name: "",        
        about_company: "",        
        phone_number: "",        
        email: "",        
        website: "",        
        address: "",   
        is_show_labels_on: 1,  
        is_show_icons_on: 1, 
        layout_is_full_width: "",    
        layout_custom_width: "auto",       
        position_alignment: "left",       
        background_color: "",       
        text_color: "#000",       
        icons_color: "#000",       
        open_status_color: "#F9AF63",       
        closed_status_color: "#B82D2D",       
        closed_soon_status_color: "#FF6600",       
        font_type: "Default",       
        text_size: "18px",       
        language_type: "English",       
        time_zone: "(GMT+05:30) Asia/Kolkata",       
        time_format: "12-hour",       
        first_day_of_the_week: "Monday",       
        day_and_month_format: "Full (Monday, January)",       
        custom_css: "",    
        custom_js: "",    
    });

    // Set Template Setting And Texts when activeTemplateSection changes
        useEffect(() => {
            let business_name = "";
            let about_company = "";
            let phone_number = "";
            let email = "";
            let website = "";
            let address = "";
            let background_color = "";
            let text_color = "";
            let icons_color = "";
            let open_status_color = "";
            let closed_status_color = "";
            let closed_soon_status_color = "";
        
            switch (activeTemplateSection) {
                case "Business_Hours_Temp":
                    business_name = "";
                    about_company = "";
                    phone_number = "";
                    email = "";
                    website = "";
                    address = "";
                    background_color = "#eee";
                    text_color = "rgb(0, 0, 0)";
                    icons_color = "#000";
                    open_status_color = "#28a745";
                    closed_status_color = "#dc3545";
                    closed_soon_status_color = "#ffc107";
                    break;
                case "Full_Business_Detail_Temp":
                    business_name = "Glowing Beauty Salon";
                    about_company = "At Glowing Beauty Salon, we are dedicated to providing high-quality beauty services in a comfortable and friendly environment. Our expert stylists offer a wide range of services including haircuts, coloring, styling, manicures, pedicures, and facial treatments.";
                    phone_number = "+1 234 567 8910";
                    email = "contact@beautysalon.com";
                    website = "https://dashboard.upgadeify.com/";
                    address = "248 E 23rd St, New York, NY 10010";
                    background_color = "#eee";
                    text_color = "rgb(0, 0, 0)";
                    icons_color = "#000";
                    open_status_color = "#28a745";
                    closed_status_color = "#dc3545";
                    closed_soon_status_color = "#ffc107";
                    break;
                case "Open_Status_Temp":
                    business_name = "";
                    about_company = "";
                    phone_number = "";
                    email = "";
                    website = "";
                    address = "";
                    background_color = "#fff";
                    text_color = "rgb(0, 0, 0)";
                    icons_color = "#000";
                    open_status_color = "#28a745";
                    closed_status_color = "#dc3545";
                    closed_soon_status_color = "#ffc107";
                    break;
                case "Hours_Contacts_Temp":
                    business_name = "";
                    about_company = "";
                    phone_number = "+1 234 567 8910";
                    email = "contact@beautysalon.com";
                    website = "https://dashboard.upgadeify.com/";
                    address = "248 E 23rd St, New York, NY 10010";
                    background_color = "#fff";
                    text_color = "rgb(0, 0, 0)";
                    icons_color = "#000";
                    open_status_color = "#28a745";
                    closed_status_color = "#dc3545";
                    closed_soon_status_color = "#ffc107";
                    break;
                case "Small_Contacts_Card_Temp":
                    business_name = "Glowing Beauty Salon";
                    about_company = "";
                    phone_number = "+1 234 567 8910";
                    email = "contact@beautysalon.com";
                    website = "";
                    address = "248 E 23rd St, New York, NY 10010";
                    background_color = "#eee";
                    text_color = "rgb(0, 0, 0)";
                    icons_color = "#000";
                    open_status_color = "#28a745";
                    closed_status_color = "#dc3545";
                    closed_soon_status_color = "#ffc107";
                    break;
                case "Dark_Contacts_Card_Temp":
                    business_name = "Glowing Beauty Salon";
                    about_company = "";
                    phone_number = "+1 234 567 8910";
                    email = "contact@beautysalon.com";
                    website = "";
                    address = "248 E 23rd St, New York, NY 10010";
                    background_color = "rgb(0, 0, 0)";
                    text_color = "#fff";
                    icons_color = "#fff";
                    open_status_color = "#28a745";
                    closed_status_color = "#dc3545";
                    closed_soon_status_color = "#ffc107";
                    break;
                default:
                    business_name = "";
                    about_company = "";
                    phone_number = "";
                    email = "";
                    website = "";
                    address = "";
                    background_color = "";
                    text_color = "";
                    icons_color = "";
                    open_status_color = "";
                    closed_status_color = "";
                    closed_soon_status_color = "";
            }
        
            // Update setBusinessHoursTabData state with the data
            setBusinessHoursTabData((prevData) => ({
                ...prevData,
                business_name: business_name,
                about_company: about_company,
                phone_number: phone_number,
                email: email,
                website: website,
                address: address,
                background_color: background_color,
                text_color: text_color,
                icons_color: icons_color,
                open_status_color: open_status_color,
                closed_status_color: closed_status_color,
                closed_soon_status_color: closed_soon_status_color,
            }));
        
        }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateBusinessHoursTabData = (key, value) => {
        setBusinessHoursTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = () => {
      setShowTemplateSelection(false);
      setIsSubmitting(false);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          setSelectedLayout(layoutTypeValue);
      } else {
          alert('Please select a template');
      }
  }; 

  const menuItems = [
      { key: "Content", icon: "content.png", label: "Content" },
      { key: "Layout", icon: "layout.png", label: "Layout" },
      { key: "Style", icon: "style.png", label: "Style" },
      { key: "Settings", icon: "setting.png", label: "Settings" },
  ];

  // Handle Source Tab input change
  const handleActiveTemplateInputChange = (event) => {
      setActiveTemplateSection(event.target.value);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          const template_image = selectedRadio.dataset.template_image;
          setSelectedLayout(layoutTypeValue);
          setSelectedTemplateImage(template_image);
      } else {
          alert('Please select a template');
      }
  };

  //Submit Review data
  const submitForm = async (e) => {
      e.preventDefault();

      setIsSubmitting(true);
      try {
        // Collect data from refs
        const settingsArray = Object.entries(businessHoursTabData).map(([key, value]) => ({
            setting_key: key,
            setting_value: value,
        }));

          // Collect data from refs
          const payload = {
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                app_type: "Business_Hours",
                settings: settingsArray,
          };
          
          //Api Call
          let api_response = await submitTemplate(payload);

          //Check Responce
          if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/business-hours');
                }, 2000); 
          } else {
              toast.error(api_response.message);
          }
      } catch (error) {
          toast.error('Oops Something Wrong. Please Try Again!' + error.message);
      } finally {
          setIsSubmitting(false);
      }
  };

  return (
    <>
      <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="Business Hours" app_type="Business_Hours" app_slug="business-hours"/>
            {showTemplateSelection ? (
                <div className="create-goole-reviews-side">
                    <span>Select a template to start with</span>
                    <div className="card h-100">
                        <div className="label-box-flex">
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Business_Hours_Temp" data-layout_type="business_hours_layout" data-template_image="business-hours.png" checked={activeTemplateSection === "Business_Hours_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/business-hours/templates/business-hours.png`} alt="business-hours" />
                                    </div> 
                                    <div className="content_sub">Business Hours</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Full_Business_Detail_Temp" data-layout_type="full_business_detail_layout" data-template_image="full-business-Detail.png" checked={activeTemplateSection === "Full_Business_Detail_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/business-hours/templates/full-business-Detail.png`} alt="full-business-Detail" />
                                    </div>
                                    <div className="content_sub">Full Business Details</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Open_Status_Temp" data-layout_type="open_status_layout" data-template_image="open-status.png" checked={activeTemplateSection === "Open_Status_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/business-hours/templates/open-status.png`} alt="open-status" />
                                    </div>
                                    <div className="content_sub">Open Status</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Hours_Contacts_Temp" data-layout_type="hours_contacts_layout" data-template_image="hours-contacts.png" checked={activeTemplateSection === "Hours_Contacts_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/business-hours/templates/hours-contacts.png`} alt="hours-contacts" />
                                    </div>
                                    <div className="content_sub">Hours & Contacts</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Small_Contacts_Card_Temp" data-layout_type="small_contacts_card_layout"  data-template_image="small-contacts-card.png" checked={activeTemplateSection === "Small_Contacts_Card_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/business-hours/templates/small-contacts-card.png`} alt="small-contacts-card" />
                                    </div>
                                    <div className="content_sub">Small Contacts Card</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Dark_Contacts_Card_Temp" data-layout_type="dark_contacts_card_layout" data-template_image="dark-contacts-card.png" checked={activeTemplateSection === "Dark_Contacts_Card_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/business-hours/templates/dark-contacts-card.png`} alt="dark-contacts-card" />
                                    </div>
                                    <div className="content_sub">Dark Contacts Card</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="continue-template">
                        <button onClick={handleContinueTemplate}>Continue with this template</button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="overlay-side-baar">
                        <div className="side-baar-inner-one">
                            <ul>
                                {menuItems.map((item) => (
                                    <li key={item.key}>
                                        <button
                                            className={activeSection === item.key ? "active" : ""}
                                            onClick={() => setActiveSection(item.key)}
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/business-hours/icons/${item.icon}`}
                                                alt={`${item.key} icon`}
                                            />
                                            <span>{item.label}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="side-baar-inner-tow">
                            {/* Conditional Rendering for Sections */}
                            {activeSection === "Content" && (
                              <ContentTab updateBusinessHoursTabData={updateBusinessHoursTabData} businessHoursTabData={businessHoursTabData} />
                            )}
                            {activeSection === "Layout" && (
                              <LayoutTab updateBusinessHoursTabData={updateBusinessHoursTabData} businessHoursTabData={businessHoursTabData} />
                            )}
                            {activeSection === "Style" && (
                              <StyleTab updateBusinessHoursTabData={updateBusinessHoursTabData} businessHoursTabData={businessHoursTabData}/>
                            )}
                            {activeSection === "Settings" && (
                              <SettingTab updateBusinessHoursTabData={updateBusinessHoursTabData} businessHoursTabData={businessHoursTabData} />
                            )}
                        </div>
                    </div>
                </>
            )}
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/business-hours"><i className="fa fa-angle-left" aria-hidden="true"></i></Link> Back</h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/business-hours/business-hours.svg`} alt="business-hours"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={submitForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/business-hours/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/business-hours" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Business Hours <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "Business_Hours_Temp" && (
                      <BusinessHoursTemplateWidget businessHoursTabData={businessHoursTabData}/>
                    )}

                    {activeTemplateSection === "Full_Business_Detail_Temp" && (
                      <FullBusinessDetailTemplateWidget businessHoursTabData={businessHoursTabData}/>
                    )}

                    {activeTemplateSection === "Open_Status_Temp" && (
                      <OpenStatusTemplateWidget businessHoursTabData={businessHoursTabData}/>
                    )}

                    {activeTemplateSection === "Hours_Contacts_Temp" && (
                      <HoursContactsTemplateWidget businessHoursTabData={businessHoursTabData}/>
                    )}

                    {activeTemplateSection === "Small_Contacts_Card_Temp" && (
                      <SmallContactsCardTemplateWidget businessHoursTabData={businessHoursTabData}/>
                    )}

                    {activeTemplateSection === "Dark_Contacts_Card_Temp" && (
                      <DarkContactsCardTemplateWidget businessHoursTabData={businessHoursTabData}/>
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 